import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
export const COPY_DENIAL_REASONS = "COPY_DENIAL_REASONS";

export const service = async (data) => {
  const options: object = {
    url: `/Api/DenialReasons/CopyDenialReason?denialReasonId=` + data.denialReasonId,
    method: "POST",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(COPY_DENIAL_REASONS, service, mock);
